// extracted by mini-css-extract-plugin
export default {"cardList":"EventList_cardList__6ytM8","carousel":"EventList_carousel__vIVR7"};